var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5923 12.5V15.8333C13.5923 17.2167 12.4757 18.3333 11.0923 18.3333H9.42566C8.04233 18.3333 6.92566 17.2167 6.92566 15.8333V12.5H13.5923Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09232 5.83366V4.16699C6.09232 2.78366 7.20898 1.66699 8.59232 1.66699H11.9256C13.309 1.66699 14.4256 2.78366 14.4256 4.16699V5.83366H6.09232Z",
    fill: "#35446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.259 5.83301H5.25899C3.59232 5.83301 2.75899 6.66634 2.75899 8.33301V12.4997C2.75899 14.1663 3.59232 14.9997 5.25899 14.9997H6.92565V12.4997H13.5923V14.9997H15.259C16.9257 14.9997 17.759 14.1663 17.759 12.4997V8.33301C17.759 6.66634 16.9257 5.83301 15.259 5.83301ZM8.59232 9.79134H6.09232C5.75065 9.79134 5.46732 9.50801 5.46732 9.16634C5.46732 8.82467 5.75065 8.54134 6.09232 8.54134H8.59232C8.93399 8.54134 9.21732 8.82467 9.21732 9.16634C9.21732 9.50801 8.93399 9.79134 8.59232 9.79134Z",
    fill: "#35446F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21732 9.16699C9.21732 9.50866 8.93398 9.79199 8.59232 9.79199H6.09232C5.75065 9.79199 5.46732 9.50866 5.46732 9.16699C5.46732 8.82533 5.75065 8.54199 6.09232 8.54199H8.59232C8.93398 8.54199 9.21732 8.82533 9.21732 9.16699Z",
    fill: "#35446F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4256 13.125H6.09232C5.75065 13.125 5.46732 12.8417 5.46732 12.5C5.46732 12.1583 5.75065 11.875 6.09232 11.875H14.4256C14.7673 11.875 15.0506 12.1583 15.0506 12.5C15.0506 12.8417 14.7673 13.125 14.4256 13.125Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.f1ddf7fbdfef57653eee25f1d2da6c75.svg";
export { ForwardRef as ReactComponent };